/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import * as Config from './config';

async function reqLogin(data) {
	const API_URI_LOGIN = Config.rutas.auth;
	try {
		const response = await axios.post(API_URI_LOGIN, data, {
			headers: { 'ApiKey': Config.apiKey },
		});		
		return response.data;
	} catch (error) {		
		return error
	}
}



export default reqLogin; 
